export default {
    language: "עברית",
    StripeSuccess: {
        loading: "מעבד את התשלום שלך...",
        successMessage: "המנוי שלך הופעל בהצלחה!",
        processingError: "עיבוד התשלום נכשל, אנא צור קשר",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "אימייל",
            createdAt: "נוצר ב",
            noRecord: "אין רשומות",
            loginTime: "זמן התחברות",
        },
        orders: {
            title: "היסטוריית הזמנות",
            loading: "טוען...",
            refresh: "רענן",
            orderAmount: "סכום",
            points: "נקודות",
            createdAt: "נוצר ב",
            orderType: "סוג",
            status: "סטטוס",
            noOrders: "אין הזמנות",
            goToSubscription: "קנה נקודות",
            freeCredit: "קרדיט חינם",
            paidCredit: "קרדיט בתשלום",
            queryOrderFailed: "שאילתת ההזמנה נכשלה",
            statusPaid: "שולם",
            statusPending: "ממתין",
            statusCancelled: "בוטל",
            statusDeactivated: "מושבת",
            checkoutUrlNotAvailable: "לא ניתן לקבל את כתובת התשלום",
            verifyingPayment: "מאמת סטטוס תשלום...",
            paymentSuccess: "התשלום הצליח",
            paymentPending: "ההזמנה ממתינה לתשלום, אנא השלם את התשלום",
            paymentFailed: "התשלום נכשל או בוטל",
            paymentStatus: "סטטוס תשלום",
            paymentStatusDescription: "האם השלמת את התשלום?",
            cancelPayment: "בטל תשלום",
            completedPayment: "תשלום הושלם",
            warning: "אזהרה",
            confirmCancelOrder: "האם אתה בטוח שברצונך לבטל הזמנה זו? פעולה זו אינה ניתנת לביטול.",
            cancel: "בטל",
            confirm: "אשר",
            cancellingOrder: "מבטל הזמנה...",
            orderCancelledSuccess: "ההזמנה בוטלה",
            cancelOrderFailed: "ביטול ההזמנה נכשל",
            checkOrderStatusFailed: "בדיקת סטטוס ההזמנה נכשלה",
            promptClick: "לחץ על סטטוס \"ממתין\" כדי להמשיך לתשלום",
        }
    },
    UserFeedback: {
        title: "חוות דעת משתמשים",
        feedback: "האזן לחוות דעת אמיתיות מיוצרים ואנשי מקצוע מרחבי העולם על טכנולוגיית עיבוד התמונות בבינה מלאכותית שלנו.",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "מר לין",
                profession: "עורך וידאו ויוצר תוכן",
                rating: 5,
                comment: "מדהים! ClixMagicAI מהיר במיוחד! העלאת וידאו עם סימן מים, תוך מספר דקות תקבלו גרסה ללא סימן מים, ללא אובדן איכות. כלי חיוני להסרת סימני מים!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "גב' סו",
                profession: "מומחית מדיה חברתית",
                rating: 5,
                comment: "ClixMagicAI הציל את ספריית התוכן שלי באינסטגרם! מזהה סימני מים מורכבים בדיוק רב, עיבוד השוליים עדין הרבה יותר מתוכנות קודמות שהשתמשתי בהן, מה שהופך את האפקט הויזואלי לטבעי יותר."
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "מר צ'ן",
                profession: "מפיק תוכן וידאו קצר",
                rating: 5,
                comment: "ClixMagicAI הופך את הסרת סימני המים לנוחה במיוחד. אני מעבד חומרים מטיקטוק בזמן נסיעה, ובהגעה למשרד מוריד ישירות את הגרסה באיכות גבוהה. היעילות מוכפלת! ברכה ליוצרי מדיה."
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "מר הואנג",
                profession: "מעצב גרפי ומנהל קריאייטיב",
                rating: 5,
                comment: "כמעצב אני מרוצה מאוד! בעיבוד תמונות עם לוגו של לקוחות, מרקם הרקע משוחזר בצורה טבעית לחלוטין, ללא סימני פוטושופ, חוסך זמן רב בפוסט-פרודקשן."
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "גב' אמילי",
                profession: "יוצרת תוכן דיגיטלי עצמאית",
                rating: 5,
                comment: "מצאתי אוצר! מחיר החברות זול בהרבה ממוצרי הסרת סימני מים אחרים בשוק, אבל תוצאות הסרת סימני המים טובות יותר, במיוחד בטיפול בסימני מים שקופים עם הדרגתיות."
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "מר רוברטסון",
                profession: "מפיק קורסי הדרכה ארגוניים",
                rating: 5,
                comment: "ClixMagicAI נוח מאוד כי אין צורך בהתקנה! מגבלות הרשאות במחשבי החברה מונעות התקנת תוכנה, עכשיו אני יכול לעבד חומרי קורס עם הדפדפן, בכל זמן ומקום."
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "גב' ג'ואו",
                profession: "עקרת בית ועורכת תמונות קהילתית",
                rating: 5,
                comment: "הממשק פשוט כל כך שאפילו סבתא שלי תוכל להשתמש בו! מי שאין לו זמן ללמוד תוכנות מקצועיות כמו פוטושופ חייב לנסות את ClixMagicAI, זה מושלם למתחילים טכניים כמוני. חה-חה~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "מר ג'ונסון",
                profession: "מתכנן ויזואלי למסחר אלקטרוני",
                rating: 5,
                comment: "ClixMagicAI חזק ביותר, מסוגל להסיר תמונות, סרטונים, חפצים קטנים, עוברי אורח, טקסט ועוד, התכונות מקיפות, אני ממליץ לכולם~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "גב' פאנג",
                profession: "חובבת צילום ומשתפת תוכן באינטרנט",
                rating: 5,
                comment: "וואו~ סוף סוף מצאתי כלי להסרת סימני מים שאינו פוגע באיכות התמונה! כמו קסם~ עריכת תמונות כבר לא בעיה! ממליצה בחום!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "מר וויליאמס",
                profession: "מדריך חינוך מקוון",
                rating: 5,
                comment: "פונקציית זיכרון מיקום סימן המים שימושית במיוחד! בעיבוד סדרות של סרטוני קורס, אינני צריך לבחור שוב ושוב את האזור, חוסך לפחות חצי שעת עבודה, משפר משמעותית את יעילות הכנת ההוראה שלי."
            }
        ]
    },
    Order: {
        purchasePoints: "רכישת נקודות",
        subtitle: "בחר חבילת נקודות מתאימה ליהנות משירות הסרת סימני מים באיכות גבוהה",
        loginReminderDesc: "התחבר כדי לבחור ולרכוש נקודות",
        freeTag: "חינם",
        freePlan: "תכנית חינמית",
        autoActivated: "מופעל אוטומטית לאחר התחברות",
        points: "נקודות",
        autoIncluded: "ניתן חינם",
        discount: "הנחה",
        purchase: "רכוש עכשיו",
        paymentStatusDescription: "האם השלמת את התשלום?",
        paymentNotCompleted: "תשלום לא הושלם",
        queryOrderFailed: "בדיקת סטטוס הזמנה נכשלה",
        cancelPayment: "ביטול תשלום",
        completedPayment: "תשלום הושלם",
        warning: "אזהרה",
        confirmCancelOrder: "האם אתה בטוח שברצונך לבטל הזמנה זו? פעולה זו אינה הפיכה.",
        cancel: "ביטול",
        confirm: "אישור",
        selectProductFirst: "אנא בחר חבילה תחילה",
        creatingOrder: "יוצר הזמנה...",
        orderCreated: "הזמנה נוצרה בהצלחה",
        createOrderFailed: "יצירת הזמנה נכשלה",
        checkoutUrlNotAvailable: "קישור תשלום אינו זמין",
        cancellingOrder: "מבטל הזמנה...",
        orderCancelledSuccess: "ההזמנה בוטלה",
        cancelOrderFailed: "ביטול הזמנה נכשל",
        verifyingPayment: "בודק סטטוס תשלום...",
        paymentSuccess: "תשלום הצליח",
        paymentPending: "הזמנה ממתינה לתשלום, אנא השלם את התשלום",
        paymentFailed: "תשלום נכשל או בוטל",
        checkOrderStatusFailed: "בדיקת סטטוס הזמנה נכשלה",
        quickStart: "התחלה מהירה",
        shortTerm: "לטווח קצר",
        recommended: "מומלץ",
        bestValue: "הכי משתלם",
    },
    Login: {
        title: "התחברות",
        subtitle: "התחברות מהירה עם חשבונות חברתיים",
        memberTip: "התחבר כדי לגשת לתכונות נוספות",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "התחבר עם GitHub"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "התחבר עם Google"
            }
        ],
        error: {
            serverError: "שגיאת שרת, נסה שוב מאוחר יותר",
            networkError: "שגיאת רשת, בדוק את החיבור שלך"
        }
    },
    OAuthCallback: {
        loading: "מעבד בקשת התחברות",
        pleaseWait: "אנא המתן, מאמת פרטי התחברות...",
        error: "התחברות נכשלה",
        backToHome: "חזרה לדף הבית",
        success: "התחברות הצליחה",
        redirecting: "מפנה לדף הבית..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "מחירים",
            faq: "שאלות נפוצות",
        },
        login: "התחברות",
        userMenu: {
            account: "חשבון",
            logout: "התנתקות",
            credit: "נקודות",
            freeCredit: "חינם",
            paidCredit: "נרכש",
            nextUpdate: "עדכון נקודות הבא",
            language: "שפה",
            theme: "ערכת נושא",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "תכונות ClixMagicAI",
        advs: [
            {
                title: "מנוע זיהוי בינה מלאכותית: איתור אוטומטי של אלמנטים מפריעים",
                desc: "מבוסס על אלגוריתמי למידה עמוקה, מזהה באופן אוטומטי סימני מים, טקסט, פנים ואלמנטים מורכבים בתמונות/וידאו, ללא צורך בסימון ידני. תומך בפורמטים של אינסטגרם, טיקטוק ופלטפורמות אחרות, עם הגנה חזקה על פרטיות הנתונים.",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "הסר סימן מים"
            },
            {
                title: "מומחה לניקוי תמונות: הסרת לוגואים/חותמות תאריך במהירות, ללא פגיעה באיכות",
                desc: "הסרה מדויקת של סימני מים, תאריכי צילום, מדבקות ואלמנטים מפריעים. הבינה המלאכותית משחזרת אוטומטית את מרקם הרקע, התמונות לאחר העיבוד נראות טבעיות כמו המקור, מושלמות לפרסום ברשתות חברתיות.",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "הסר סימן מים"
            },
            {
                title: "מסיר סימני מים דינמיים: מחיקת כתוביות נעות/לוגואים של פלטפורמות",
                desc: "הסרה בלחיצה אחת של סיומות YouTube, סימני מים של טיקטוק וטקסט נע. הבינה המלאכותית עוקבת ומעבדת כל פריים, מייצרת סרטוני 4K באיכות גבוהה, תומכת בפורמטים MP4/MOV ופורמטים נפוצים אחרים.",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "הסר סימן מים"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "כלי מקצועי מבוסס בינה מלאכותית להסרת סימני מים מתמונות, סרטונים ו-PDF במהירות, קל לשימוש ובתוצאות טבעיות.",
        fileTypes: {
            image: 'הסרת סימני מים מתמונות',
            pdf: 'הסרת סימני מים מ-PDF',
            video: 'הסרת סימני מים מסרטונים'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "ניסיון חינם יומי", icon: "fa-gift" },
            { id: "imageTag", text: "הסרת סימני מים מתמונות", icon: "fa-image" },
            { id: "videoTag", text: "הסרת סימני מים מסרטונים", icon: "fa-video" },
            { id: "aiPoweredTag", text: "מופעל בבינה מלאכותית", icon: "fa-robot" },
            { id: "noRegTag", text: "התחבר והשתמש", icon: "fa-user-check" },
        ],
        videoPromt: "בקרוב!",
        videoDesc: "אנחנו מפתחים את הסרת סימני המים מסרטונים כדי להציע לך חוויה חזקה יותר."
    },
    Footer: {
        social: {
            title: "צור קשר",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:support@clixmagic.com",
                    text: "support@clixmagic.com"
                },
            ]
        },
        termsTitle: "תנאים משפטיים",
        terms: [
            {
                id: 1,
                title: "מדיניות פרטיות",
                link: "/privacy"
            },
            {
                id: 2,
                title: "תנאי שימוש",
                link: "/terms"
            },
            {
                id: 3,
                title: "מדיניות עוגיות",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI כל הזכויות שמורות."
    },
    Task: {
        image: {
            imageSupportText: 'תומך בפורמטים jpg, jpeg, png, webp, heic, heif, מקסימום 10MB לקובץ',
            imageFileTooLarge: 'גודל קובץ חורג ממגבלה (מקס. 10MB)',
            invalidImageType: 'פורמט תמונה לא נתמך, העלה JPG, JPEG, PNG, WEBP, HEIC או HEIF',
            imageWillCost: 'עלות: 1 נקודה',
            hiecSupportText: 'פורמטים HEIC/HEIF יומרו אוטומטית ל-PNG בעת שליחה',
            hiecSuccess: 'המרת HEIC/HEIF הצליחה',
            hiecFailed: 'המרת HEIC/HEIF נכשלה',
            processingImageTip: 'מעבד את התמונה שלך, אנא המתן...',
            guide: {
                title: 'מדריך',
                step1: 'העלה תמונה',
                step2: 'סמן אזור סימן מים או תן למודל לזהות אוטומטית',
                step3: 'לחץ על שליחה'
            }
        },
        common: {
            remaining: 'נקודות נותרו',
            nextUpdate: 'עדכון נקודות הבא',
            handleError: 'שגיאה בעיבוד קובץ, נסה קובץ אחר',
            uploadFailed: 'העלאה נכשלה',
            dragText: 'גרור קבצים לכאן או',
            clickText: 'לחץ להעלאה',
            loginRequired: 'אנא התחבר לפני העלאת קבצים',
            noRemainingTasks: 'השתמשת בכל הנקודות שלך',
            loginNow: 'התחבר עכשיו',
            upgradeNow: 'רכוש נקודות עכשיו',
            taskSubmitSuccess: 'משימה נשלחה בהצלחה',
            taskSubmitError: 'שליחת משימה נכשלה',
            taskRetrySuccess: 'ניסיון חוזר נשלח בהצלחה!',
            taskRetryError: 'ניסיון חוזר נכשל!',
            processing: 'מעבד',
            submit: 'שלח',
            waiting: 'ממתין',
            completed: 'הושלם',
            failed: 'נכשל',
            cancelled: 'בוטל',
            url_not_found: 'קישור לא נמצא',
            deleted: 'נמחק',
            refreshSuccess: 'רשימת משימות רועננה',
            refreshFailed: 'רענון רשימת משימות נכשל',
            deleteSuccess: 'משימה נמחקה בהצלחה',
            deleteFailed: 'מחיקת משימה נכשלה',
            waitingForCompletion: 'אנא המתן להשלמת המשימה הנוכחית לפני ניסיון חוזר',
            loadOriginalImageFailed: 'טעינת תמונה מקורית נכשלה, נסה שוב',
            downloadFailed: 'הורדה נכשלה',
            startingDownload: 'מתחיל הורדה...',
            noTasks: 'אין משימות',
            refresh: 'רענן',
            sort: 'מיון',
            noFilterTasks: 'אין משימות {filter}',
            compare: 'השווה',
            originalImage: 'מקורי',
            processedImage: 'מעובד',
            dragToCompare: '👈 גרור להשוואה 👉',
            cancel: "ביטול",
            delete: "מחק",
            retry: "נסה שוב",
            download: "הורדה",
            createAt: "נוצר ב",
            expiredAt: "פג תוקף ב",
        },
        video: {
            videoSupportText: 'תומך בפורמטים mp4, mov, avi, mkv, מקסימום 100MB לקובץ',
            videoFileTooLarge: 'גודל קובץ חורג ממגבלה (מקס. 100MB)',
            invalidVideoType: 'פורמט וידאו לא נתמך, העלה MP4, MOV, AVI או MKV',
            videoWillCost: 'עלות: 3 נקודות',
            processingVideoTip: 'מעבד את הסרטון שלך, אנא המתן...',
            guide: {
                step1: 'העלה סרטון',
                step2: 'בחר סוג סימן מים והגדר אזור',
                step3: 'לחץ על שליחה'
            },
            annotationTools: 'כלי סימון',
            selectType: 'בחר סוג סימן מים',
            deleteAnnotation: 'מחק סימון',
            clearAllAnnotations: 'נקה את כל הסימונים',
            annotationHelp: 'עזרה בסימון',
            dragTip: 'גרור לציור אזור סימן מים',
            resizeTip: 'שנה גודל להתאמה לסימן המים',
            moveTip: 'ניתן להזיז סימונים שנוצרו',
            processing: 'מעבד',
            submit: 'שלח',
            taskSubmitSuccess: 'משימה נשלחה בהצלחה',
            taskSubmitError: 'שליחת משימה נכשלה',
            retryTaskTip: 'ניסיון חוזר הצליח',
            retryFailed: 'ניסיון חוזר נכשל',
            uploadFailed: 'העלאה נכשלה',
            staticWatermarkDesc: 'לסימני מים סטטיים במיקום קבוע',
            normalWatermarkDesc: 'לסימני מים קבועים רגילים',
            dynamicWatermarkDesc: 'לסימני מים דינמיים משתנים',
            moveWatermarkDesc: 'לסימני מים הדורשים תזוזה'
        },
    },
    Router: {
        home: "דף הבית",
        terms: "תנאי שירות",
        privacy: "מדיניות פרטיות",
        cookie: "מדיניות עוגיות",
        user: "מרכז המשתמש",
    },
    Terms: {
        "tabs": {
            "terms": "תנאי שימוש",
            "privacy": "מדיניות פרטיות",
            "cookies": "מדיניות עוגיות"
        },
        "lastUpdated": "עדכון אחרון: 20 במאי, 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. מבוא",
                    "description": "ברוכים הבאים ל-ClixMagicAI. השימוש בשירותים שלנו מהווה הסכמה לתנאי שירות אלה. אנא קרא אותם בעיון."
                },
                {
                    "title": "2. תיאור השירות",
                    "description": "ClixMagicAI מספקת כלים מבוססי בינה מלאכותית להסרת סימני מים מתמונות, סרטונים ו-PDF. השירותים שלנו מתאימים לשימושים החוקיים הבאים:",
                    "items": [
                        "הסרת סימני מים מהתוכן שלך",
                        "הסרת סימני מים מתוכן שיש לך זכות מתאימה לשנות",
                        "למטרות חינוכיות ומחקריות"
                    ]
                },
                {
                    "title": "3. אחריות המשתמש",
                    "description": "בשימוש ב-ClixMagicAI, אתה מסכים כי:",
                    "items": [
                        "תעלה רק תוכן שהנו בבעלותך או שיש לך זכות מתאימה לשנות",
                        "לא תשתמש בשירותים שלנו למטרות בלתי חוקיות או להפרת חוק כלשהו",
                        "לא תנסה לעקוף את אמצעי האבטחה שלנו או את מגבלות השימוש",
                        "לא תשתמש בשירותים שלנו להפרת זכויות קניין רוחני של אחרים"
                    ]
                },
                {
                    "title": "4. תנאי חשבון",
                    "description": "ייתכן שתצטרך ליצור חשבון כדי להשתמש בחלק מהשירותים שלנו. להתחברות, תוכל להשתמש בחשבון Google או GitHub. אתה אחראי עבור:",
                    "items": [
                        "שמירה על אבטחת החשבון שלך",
                        "כל הפעילויות שמתרחשות תחת החשבון שלך",
                        "מתן מידע חשבון מדויק (כולל תמונת פרופיל, כתובת דוא\"ל, שם משתמש ומזהה משתמש)"
                    ]
                },
                {
                    "title": "5. שירותים בחינם ובתשלום",
                    "description": "ClixMagicAI מציעה מכסה בסיסית בחינם ואפשרויות רכישת נקודות גמישות לגישה לתכונות הסרת סימני המים שלנו:",
                    "items": [
                        "מכסה בסיסית: כל משתמש יקבל אוטומטית 3 נקודות חינם מדי יום, לשימוש בעיבוד תוכן",
                        "כללי צריכת נקודות: הסרת סימן מים מתמונה צורכת 1 נקודה לפעולה, הסרת סימן מים מסרטון צורכת 3 נקודות לפעולה",
                        "רכישת נקודות: אתה יכול לרכוש חבילות נקודות לשימוש נוסף, כל הנקודות שנרכשו תקפות לצמיתות, ללא מגבלות פקיעת תוקף",
                        "מדיניות החזרים: בשל האופי המיידי והווירטואלי של השירותים הדיגיטליים, לא ניתן להחזיר נקודות שנרכשו בהצלחה"
                    ]
                },
                {
                    "title": "6. זכויות קניין רוחני",
                    "description": "שירותי ClixMagicAI, כולל כל התוכנה, העיצובים והתוכן שנוצרו על ידינו, הם הקניין הרוחני שלנו. ללא רשות, אינך רשאי להעתיק, לשנות או ליצור עבודות נגזרות המבוססות על השירותים שלנו."
                },
                {
                    "title": "7. הגבלת אחריות",
                    "description": "ClixMagicAI מספקת את השירותים \"כפי שהם\", ללא אחריות מכל סוג שהוא. איננו אחראים לכל נזק שנגרם כתוצאה משימוש בשירותים שלנו."
                },
                {
                    "title": "8. שינויים בתנאים",
                    "description": "אנו עשויים לשנות תנאים אלה בכל עת. המשך השימוש ב-ClixMagicAI לאחר שינויים בתנאים מהווה הסכמה לתנאים המעודכנים."
                },
                {
                    "title": "9. סיום",
                    "description": "אנו שומרים לעצמנו את הזכות להפסיק או להשעות מיד את הגישה שלך לשירותים שלנו, ללא הודעה מוקדמת, אם אנו מאמינים כי התנהגותך מפרה תנאים אלה או מזיקה למשתמשים אחרים, לנו או לצדדים שלישיים."
                },
                {
                    "title": "10. החוק החל",
                    "description": "תנאים אלה יהיו כפופים לחוקים החלים במקום הרישום של החברה שלנו, מבלי להתחשב בהוראות סתירת החוקים."
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. מבוא",
                    "description": "ב-ClixMagicAI, אנו מעריכים את פרטיותך ומחויבים להגן על הנתונים האישיים שלך. מדיניות פרטיות זו מסבירה כיצד אנו אוספים, משתמשים ומגנים על המידע שלך כאשר אתה משתמש באתר ובשירותים שלנו. בגישה לאתר שלנו או בשימוש בשירותים כלשהם, אתה מסכים לשיטות עיבוד הנתונים המתוארות במדיניות זו. אנו מצייתים לתקנות הגנת הנתונים החלות."
                },
                {
                    "title": "2. המידע שאנו אוספים",
                    "description": "אנו עשויים לאסוף את סוגי המידע הבאים:",
                    "items": [
                        { "bold": "פרטי חשבון", "text": "תמונת פרופיל משתמש, כתובת דוא\"ל, שם משתמש ומזהה משתמש שסופקו בעת התחברות באמצעות Google או GitHub" },
                        { "bold": "נתוני שימוש", "text": "מידע על איך אתה משתמש בשירותים שלנו, כולל תכונות שניגשת אליהן וזמני שימוש" },
                        { "bold": "תוכן שהועלה", "text": "תמונות, סרטונים או קבצי PDF שאתה מעלה לעיבוד" },
                        { "bold": "פרטי תשלום", "text": "פרטי תשלום בעת רכישת מנויים (מעובדים בצורה מאובטחת על ידי שערי תשלום של צד שלישי כמו Creem/Stripe/PayPal, אנו שומרים רק רישום של סטטוס התשלום)" },
                        { "bold": "נתונים טכניים", "text": "כתובת IP, סוג דפדפן, פרטי מכשיר" }
                    ]
                },
                {
                    "title": "3. כיצד אנו משתמשים במידע שלך",
                    "description": "אנו משתמשים במידע שלך:",
                    "items": [
                        { "text": "לספק, לתחזק ולשפר את השירותים שלנו" },
                        { "text": "לעבד ולהשלים עסקאות" },
                        { "text": "לשלוח הודעות טכניות והודעות תמיכה" },
                        { "text": "להגיב לתגובותיך ושאלותיך" },
                        { "text": "לנתח דפוסי שימוש כדי לשפר את חוויית המשתמש, ולעבד נתונים אישיים רק במידה הנדרשת למטרות השירות" },
                        { "text": "להבטיח שתקופות השמירה של נתונים אישיים אינן ארוכות מהנדרש" },
                        { "text": "למנוע הונאה או פעילות בלתי חוקית" }
                    ]
                },
                {
                    "title": "4. אבטחת נתונים",
                    "description": "אנו מיישמים אמצעי אבטחה בתקן תעשייתי כדי להגן על המידע האישי שלך:",
                    "items": [
                        { "text": "קבצים מוצפנים ב-AES-256 בהעברה ובאחסון" },
                        { "text": "נתונים רגישים מעובדים באמצעות ארכיטקטורת ידע-אפס" },
                        { "text": "ביקורת יומית של יומני אבטחה וסריקות פגיעות" },
                        { "text": "גישת עובדים בהתאם למדיניות הרשאות מינימליות" }
                    ]
                },
                {
                    "title": "5. שיתוף נתונים",
                    "description": "איננו מוכרים את המידע האישי שלך. אנו עשויים לשתף מידע עם הצדדים הבאים:",
                    "items": [
                        { "bold": "ספקי שירות", "text": "מוגבל לעיבוד נתונים הנדרש רק לצורך מתן שירותים ספציפיים (כגון אחסון בענן של CloundFlare, שערי תשלום של צד שלישי כמו Creem/Stripe/PayPal), וכפוף להסכמי עיבוד נתונים" },
                        { "bold": "דרישות חוקיות", "text": "כאשר אנו מקבלים צו, צו בית משפט או הליך משפטי חל אחר" }
                    ]
                },
                {
                    "title": "6. הזכויות שלך",
                    "description": "בהתאם לחוקים החלים באזור שלך, ייתכן שיהיו לך הזכויות הבאות:",
                    "items": [
                        { "text": "לגשת לעותק של הנתונים האישיים שלך" },
                        { "text": "לתקן מידע לא מדויק או לא שלם" },
                        { "text": "זכות למחיקת נתונים ('הזכות להישכח'), אלא אם יש לנו סיבה חוקית לשמור עליהם" },
                        { "text": "להתנגד או להגביל סוגים מסוימים של עיבוד נתונים" },
                        { "text": "זכות לניוד נתונים, שתאפשר לך לבקש העברת הנתונים שלך" }
                    ]
                },
                {
                    "title": "7. פרטיות ילדים",
                    "description": "השירותים שלנו אינם מיועדים לילדים מתחת לגיל 16. בהתאם לסעיף 8 של התקנה הכללית להגנת מידע (GDPR), הסכמה עבור ילדים מתחת לגיל 16 חייבת להינתן על ידי ההורה או האפוטרופוס שלהם. אם נודע לך שילד מתחת לגיל 16 סיפק לנו מידע אישי, אנא צור איתנו קשר מיד בכתובת support@clixmagic.com."
                },
                {
                    "title": "8. שינויים במדיניות זו",
                    "description": "אנו עשויים לעדכן מדיניות פרטיות זו מעת לעת. אנו נפרסם את המדיניות החדשה בדף זה ונעדכן את תאריך \"עדכון אחרון\"."
                },
                {
                    "title": "9. צור קשר",
                    "description": "אם יש לך שאלות כלשהן לגבי מדיניות הפרטיות הזו, אנא צור קשר בכתובת support@clixmagic.com. אם אתה מאמין שהנתונים שלך עובדו באופן לא ראוי או שיש לך חששות אחרים, אל תהסס לפנות אלינו בכל עת."
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. מהן עוגיות",
                    "description": "עוגיות הן קבצי טקסט קטנים המוצבים על המחשב או המכשיר הנייד שלך כאשר אתה מבקר באתרים. הם מאפשרים לאתר לזהות את המכשיר שלך ולזכור אם ביקרת באתר בעבר."
                },
                {
                    "title": "2. כיצד אנו משתמשים בעוגיות",
                    "description": "ClixMagicAI משתמשת בעוגיות למגוון מטרות:",
                    "items": [
                        { "bold": "עוגיות הכרחיות", "text": "נדרשות לפונקציונליות בסיסית של האתר שלנו (כגון ניהול סשן ותכונות אבטחה)" },
                        { "bold": "עוגיות העדפות", "text": "זוכרות את ההגדרות וההעדפות שלך כדי לשפר את החוויה שלך, כגון זכירת תמונת הפרופיל, שם המשתמש וכו' לאחר התחברות באמצעות Google או GitHub" },
                        { "bold": "עוגיות ניתוח", "text": "עוזרות לנו להבין כיצד מבקרים מתקשרים עם האתר שלנו על ידי איסוף מידע אנונימי" },
                        { "bold": "עוגיות שיווק", "text": "מספקות פרסומות המתאימות לעניין שלך על ידי מעקב אחר הרגלי הגלישה שלך" }
                    ]
                },
                {
                    "title": "3. סוגי העוגיות בהן אנו משתמשים",
                    "subsection": [
                        {
                            "title": "3.1 עוגיות הכרחיות",
                            "description": "עוגיות אלה חיוניות לתפקוד התקין של האתר. הן מאפשרות פונקציות ליבה כמו אבטחה, ניהול רשת וגישה לחשבון (כולל התחברות Google ו-GitHub). אתה יכול להגדיר את הדפדפן שלך לחסום עוגיות אלה, אך חלקים מהאתר עלולים שלא לעבוד כראוי."
                        },
                        {
                            "title": "3.2 עוגיות ביצועים וניתוח",
                            "description": "עוגיות אלה אוספות מידע אנונימי שעוזר לנו להבין כיצד מבקרים מתקשרים עם האתר שלנו. אנו משתמשים בנתונים אלה כדי לשפר את האתר והשירותים שלנו. עוגיות אלה אינן אוספות מידע שיכול לזהות מבקרים."
                        },
                        {
                            "title": "3.3 עוגיות פונקציונליות",
                            "description": "עוגיות אלה מאפשרות לאתר שלנו לזכור את ההעדפות שביצעת (כגון העדפות שפה או סטטוס התחברות) כדי לספק תכונות מותאמות אישית משופרות, כמו זכירת סטטוס ההתחברות שלך באמצעות Google או GitHub."
                        },
                        {
                            "title": "3.4 עוגיות מיקוד ופרסום",
                            "description": "עוגיות אלה משמשות להצגת פרסומות רלוונטיות למבקרים ולמעקב אחר האפקטיביות של קמפיינים פרסומיים שלנו. שים לב שמכיוון שהאתר שלנו מסתמך בעיקר על התחברות צד שלישי (Google ו-GitHub), עוגיות מסוג זה משמשות בעיקר לשיפור חוויית המשתמש ולא לשיווק ישיר."
                        }
                    ]
                },
                {
                    "title": "4. ניהול עוגיות",
                    "description": "אתה יכול לשלוט ולנהל עוגיות במספר דרכים. רוב דפדפני האינטרנט מאפשרים לך לנהל את העדפות העוגיות שלך. אתה יכול:",
                    "items": [
                        { "text": "למחוק עוגיות מהמכשיר שלך" },
                        { "text": "לחסום עוגיות על ידי הפעלת הגדרות הדפדפן שמאפשרות לך לדחות את כל העוגיות או חלקן" },
                        { "text": "להגדיר את הדפדפן שלך להודיע לך כאשר אתה מקבל עוגיה" }
                    ]
                },
                {
                    "title": "5. עוגיות צד שלישי",
                    "description": "חלק מהעוגיות מוצבות על ידי צדדים שלישיים באתר שלנו. צדדים שלישיים אלה עשויים לכלול שירותי ניתוח (כמו Google Analytics) ורשתות פרסום. בגלל האופן שבו עוגיות פועלות (עוגיות נגישות רק על ידי המפלגה שהגדירה אותן במקור), איננו שולטים בשימוש בעוגיות צד שלישי אלה או יכולים לגשת אליהן. עבור משתמשים שמתחברים דרך Google ו-GitHub, נקפיד לעקוב אחר הנחיות הפרטיות של פלטפורמות אלה בטיפול במידע הקשור."
                },
                {
                    "title": "6. עדכונים למדיניות עוגיות זו",
                    "description": "אנו עשויים לעדכן את מדיניות העוגיות הזו מעת לעת כדי לשקף שינויים בטכנולוגיה, בתקנות או בנוהגי העסקים שלנו. כל שינויים יפורסמו בדף זה ויעודכן תאריך העדכון."
                },
                {
                    "title": "7. צור קשר",
                    "description": "אם יש לך שאלות כלשהן לגבי השימוש שלנו בעוגיות, אנא צור קשר בכתובת support@clixmagic.com."
                }
            ]
        }
    },
    FAQ: {
        title: "מדריך שימוש ושאלות נפוצות של ClixMagicAI",
        prompt: "נתקלת בבעיה או יש לך שאלה? צור קשר בכל עת: support@clixmagic.com",
        questions: [
            {
                id : 1,
                question: "מהו ClixMagicAI וכיצד הוא עובד?",
                answer: "ClixMagicAI הוא כלי מתקדם להסרת סימני מים המופעל על ידי בינה מלאכותית. הוא תומך בזיהוי אוטומטי של סימני מים בתמונות ובסרטונים, ומציע פונקציה לסימון ידני של מיקומי סימני המים. לתמונות, הוא תומך במספר פורמטים להמרה ומבטיח פלט באיכות גבוהה; לסרטונים, הוא יכול לטפל בסימני מים סטטיים, דינמיים ואפילו משתני צורה."
            },
            {
                id : 2,
                question: "האם ClixMagicAI מציע שימוש חינמי?",
                answer: "כן, אנחנו מציעים שירות בסיסי חינמי של 3 נקודות ביום! אתה יכול להשתמש בהן לעיבוד תמונות (1 נקודה לפעולה) או סרטונים (3 נקודות לפעולה). בנוסף, תוכל לרכוש נקודות נוספות שיהיו תקפות לצמיתות."
            },
            {
                id : 3,
                question: "האם אני יכול לרכוש נקודות נוספות?",
                answer: "בהחלט! בנוסף ל-3 נקודות החינמיות הניתנות מדי יום, תוכל להשיג נקודות נוספות דרך אפשרויות הרכישה שלנו. הנקודות שנרכשו תקפות לצמיתות, ללא תאריך תפוגה."
            },
            {
                id : 4,
                question: "אילו פורמטים נתמכים?",
                answer: "לתמונות, אנחנו תומכים בפורמטים PNG, JPEG, JPG, WEBP, HEIC ו-HEIF, כאשר HEIC ו-HEIF יומרו אוטומטית ל-PNG. לסרטונים, אנחנו תומכים במספר פורמטים, כולל MP4 ו-MOV."
            },
            {
                id : 5,
                question: "כיצד מוגנת הפרטיות שלי?",
                answer: "ב-ClixMagicAI, אנו מעריכים מאוד את פרטיות המשתמש. כל הקבצים שהועלו מוצפנים ונמחקים אוטומטית 24 שעות לאחר השלמת העיבוד. איננו שומרים קבצי משתמש או מידע קשור כלשהו."
            },
            {
                id : 6,
                question: "כיצד אני יכול להתחבר ל-ClixMagicAI?",
                answer: "אנו תומכים בהתחברות מהירה באמצעות חשבונות GitHub או Google, מבטיחים את אבטחת החשבון שלך תוך פישוט תהליך ההרשמה."
            },
            {
                id : 7,
                question: "מהי מהירות העיבוד?",
                answer: "הודות לשרתים בעלי ביצועים גבוהים ואלגוריתמי בינה מלאכותית מותאמים, רוב משימות הסרת סימני המים בתמונות מושלמות תוך 10 שניות, בעוד שהסרת סימני מים בסרטונים יכולה להימשך דקה אחת בלבד. הזמן בפועל עשוי להשתנות בהתאם לגודל ולמורכבות הקובץ."
            },
            {
                id : 8,
                question: "איך התוצאות לאחר העיבוד?",
                answer: "מודלי הבינה המלאכותית שלנו עברו אימון נרחב כדי להסיר בחוכמה סימני מים מתמונות וסרטונים, תוך שמירה על איכות התוכן המקורי. סימני מים שזוהו אוטומטית וגם אלו שסומנו ידנית מוסרים ביעילות, מבטיחים תוצאות טבעיות ללא עקבות."
            },
            {
                id : 9,
                question: "מהו משך התוקף של כל משימה?",
                answer: "לאחר השלמת המשימה, הקבצים המעובדים נשארים זמינים ב-ClixMagicAI למשך 24 שעות להורדה. לאחר תקופה זו, הקבצים נמחקים אוטומטית מהשרתים שלנו כדי להגן על הפרטיות שלך."
            },
            {
                id : 10,
                question: "מהי מגבלת הגודל המקסימלית של קובץ?",
                answer: "אנו מקבלים תמונות בגודל של עד 10MB וקבצי וידאו בגודל של עד 100MB. קבצים החורגים ממגבלות אלה עשויים לדרוש דחיסה או חיתוך לפני העלאה."
            }
        ]
    }
}